import artifact from '$houdini/artifacts/SaveFavoriteReports'
import { MutationStore } from '../runtime/stores/mutation'

export class SaveFavoriteReportsStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
